import React, { useEffect, useRef, useState } from "react";
import Reactportal from "../../Reactportal/Reactportal";
import { FormInputSectionComponent } from "../../FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Reactportal/PortalFooter";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import { Confirm } from "../../Confirmation/Confirm";
import { StockGroupConfig } from "./AddStockGroup.config";
import { useSelector } from "react-redux";
import { CREATE_STOCK_GROUP, EDIT_STOCK_GROUP, GetStockDataByID } from "../../../../Utils/AllPagesQuriesAndMutations";
import { useLazyQuery, useMutation } from "@apollo/client";
import { useDispatch } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import { useGetPageData } from "../../../custom_hooks/useGetPageData";
import { replaceUnderscore } from "../../../../CommonFunction/common";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import { useModalContext } from "../../Reactportal/ModalContext";

import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";

const AddStockGroup = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  const Form_Key = "Stock_Group";
  const formRef = useRef({});
  const { pushModal, popModal, getTopModal } = useModalContext();
  const fieldDataRedux = useSelector((store) => store.UniqueTableReducer);
  const fieldData = fieldDataRedux?.Stock_Group?.Selected_Row;

  const [allFieldsData, setAllFieldsData] = useState({});
  const [field, setFields] = useState(StockGroupConfig);
  const dispatch = useDispatch();
  const [ConfirmMerge, SetConfirmMerge] = useState(false);
  const [toggle, setToggle] = useState(show ? show : false);
  const [formErrors, setFormErrors] = useState({});

  const [selectedRows, setSelectedRows] = useState([]);
  const [FormData, setFormdata] = useState({});
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);

  const [GetStockGroupByID, { loading: GetStockGroupByIDLoader }] = useLazyQuery(GetStockDataByID, {
    fetchPolicy: "network-only",
  });

  const [CreatingData, { loading: createStockGroupLoading }] = useMutation(CREATE_STOCK_GROUP);

  const [EditingData, { loading: editStockGroupLoading }] = useMutation(EDIT_STOCK_GROUP);

  const AccountGroupLoadingState = createStockGroupLoading || editStockGroupLoading || GetStockGroupByIDLoader;

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  useEffect(() => {
    setSelectedRows(fieldDataRedux?.Stock_Group?.Selected_Rows);
  }, [fieldDataRedux]);

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  useEffect(() => {
    if (TypeOfPortal !== "Add") {
      GetStockGroupByID({
        variables: {
          id: fieldData?._id,
        },
      }).then(({ data }) => {
        let GroupData = { ...data?.getStockGroupByID };
        dispatch({
          type: "StoreMasterData",
          payload: {
            formkey: Form_Key,
            data: {
              Group_Under: GroupData.Group_Under,
              Tax_Code: GroupData?.Tax_Code,
            },
          },
        });
        if (GroupData?.Group_Under && GroupData?.Tax_Code) {
          GroupData.Group_Under = GroupData?.Group_Under?.Group_Name;
          GroupData.Tax_Code = GroupData?.Tax_Code?.Description;
        }
        setAllFieldsData(GroupData);
        updateValueForm(formRef, GroupData);
      });
    } else {
      setAllFieldsData({});
    }
  }, [fieldData, GetStockGroupByID, TypeOfPortal, dispatch]);

  const { executeOperation } = useSubmitOperation();
  let formData = FormData;
  const operationType = TypeOfPortal;

  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, formData, selectedRows);

  const MutationFunctions = {
    CreatingData,
    EditingData,
    // MergingData,
  };

  const submit = async (closeAction) => {
    let Name = ReferenceFieldName[0]?.name;
    formData.Group_Under = FormDataFromRedux?.MasterData[Form_Key]?.Group_Under?._id;
    formData.Tax_Code = FormDataFromRedux?.MasterData[Form_Key]?.Tax_Code?._id;
    const mutationFunction = getMutationFunction(operationType, MutationFunctions);

    const executeOperationFunction = () =>
      executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,

        PageName: Form_Key,
        OnSuccess: (res) => {
          console.log(res);
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.createStockGroup || res?.data?.editStockGroup,
              },
            },
          });
          handleFormReset(formRef);
        },
      });

    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: closeFormFunction,
      resetFormDataFunction: setAllFieldsData,
      onSuccess: () => {},
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const closeFormFunction = () => {
    popModal(Form_Key);
    ParentPortalCloseFunction();
    setToggle(false);
    setAllFieldsData({});
    ClearSpecificForm(dispatch, Form_Key);
  };
  const SaveAndCloseForAdd = () => {
    submit("Close");
  };
  const ConfirmModalOpen = () => {
    SetConfirmMerge(true);
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      Form_key={Form_Key}
      TypeOfPortal={TypeOfPortal}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => Validate_handleSubmit(SaveAndCloseForAdd)
          : TypeOfPortal === "Merge"
          ? () => ConfirmModalOpen()
          : () => Validate_handleSubmit(submit)
      }
      handleformclose={() => {
        closeFormFunction();
        setToggle(!toggle);
      }}
      loadingState={AccountGroupLoadingState}
    />
  );
  return (
    <>
      <div>
        <Reactportal
          FoooterContent={footerContent}
          open={toggle}
          onClose={closeFormFunction}
          TypeOfPortal={TypeOfPortal + " Stock Group"}
        >
          {AccountGroupLoadingState && <div className="loader-line-div" />}
          <div className="formContainer">
            {field.map((e) => {
              return (
                <div key={e.id} className="FormSectionParent">
                  <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                  <div className="FormSection insidecontainer">
                    <FormInputSectionComponent
                      handelformikdata=""
                      inputfields={e.fields}
                      Type={e.name}
                      fielddata={allFieldsData}
                      validation_Schema={e.Valid_schema}
                      onErrorsChange={(newErrors) => handleErrorsChange(newErrors)}
                      HanldeChangeonForm={HanldeChangeonForm}
                      formkey={Form_Key}
                      formRef={formRef}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </Reactportal>
      </div>
      {ConfirmMerge && (
        <Confirm
          submit={submit}
          settoggle={SetConfirmMerge}
          toggle={ConfirmMerge}
          loadingState={AccountGroupLoadingState}
          submitType={"Confirm Merge"}
          TypeOfPortal={"Confirm"}
        />
      )}
    </>
  );
};

export default AddStockGroup;
